module.exports = __webpack_public_path__ + "img/1.5bcc74ab.png";